import React from 'react';

import s from './FixedSecondaryHeaderBar.css';
import cx from 'classnames';


const FixedSecondaryHeaderBar = ({ className, children }) =>
    <nav className={cx(s.component, className)}>
      {children}
    </nav>;

export default FixedSecondaryHeaderBar;


// WEBPACK FOOTER //
// ./src/components/FixedSecondaryHeaderBar/FixedSecondaryHeaderBar.js